import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";


const GrowingWithChild = () => {

    const images = window.GROWING_WITH_CHILD_IMAGES || [];

    return (
        <><div class='bg-[url(flexbag-grow-with-child-bg.png)] bg-no-repeat 
        bg-cover pad-l-30 pad-r-30 items-center flex flex-col h-[100%]
        pad-t-40 md:pad-t-50 lg:pad-t-85 xl:pad-t-200
        '>
            <p class="
            text-4xl md:text-2xl lg:text-3xl xl:text-4xl 
            mx-auto font-Unbounded 
            text-primary 
            w-full md:max-w-full lg:max-w-2/3 xl:max-w-2/3
            font-semibold pad-b-25 lh-1_2 text-left 
            text-left md:text-left lg:text-left xl:text-left
          ">
                Growing with your child
            </p>
            <p class='md:pad-1 text-primary-dark mt-4 text-l font-worksans pad-b-25 mx-auto text-left md:text-center w-full md:max-w-3/5
        w-full md:max-w-full lg:max-w-2/3 xl:max-w-2/3
        text-left md:text-left lg:text-left xl:text-left'>
                As your little one grows, so does our product line! Look out for our upcoming Flexbag TWO - the perfect next step for elementary school adventures.
            </p>
        </div>
            <div>
                <img
                    src={images[0]}
                    alt='Growing with your Child'>
                </img>
            </div></>
    );
};

// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-growingwithchild");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<GrowingWithChild />);
}
